export const Storage = {
  getHistory() {
    try {
      const data = localStorage.getItem('meetingHistory');
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('Error reading history:', error);
      return [];
    }
  },

  saveMeeting(meetingData) {
    try {
      let history = this.getHistory();

      // Prevent duplicate saves of the same meeting (e.g. double-mount in StrictMode)
      const last = history[0];
      if (last) {
        const sameParticipants = last.participants === meetingData.participants;
        const sameDuration = Math.abs((last.durationSeconds || 0) - (meetingData.durationSeconds || 0)) < 5; // within 5 seconds
        const costDiff = Math.abs((last.totalCost || 0) - (meetingData.totalCost || 0));
        const sameCost = costDiff < 0.01; // small tolerance for float rounding
        
        // Check if saved within last 2 seconds (likely a duplicate)
        const timeDiff = Date.now() - (last.id || 0);
        const recentSave = timeDiff < 2000;
        
        if (sameParticipants && sameDuration && sameCost && recentSave) {
          // Already saved — return existing entry instead of creating a duplicate
          return last;
        }
      }

      const meeting = {
        id: Date.now(),
        date: new Date().toISOString(),
        ...meetingData
      };
      history.unshift(meeting);
      history = history.slice(0, 10); // Keep last 10 meetings
      localStorage.setItem('meetingHistory', JSON.stringify(history));
      return meeting;
    } catch (error) {
      console.error('Error saving meeting:', error);
      return null;
    }
  },

  deleteMeeting(id) {
    try {
      let history = this.getHistory();
      history = history.filter(m => m.id !== parseInt(id));
      localStorage.setItem('meetingHistory', JSON.stringify(history));
    } catch (error) {
      console.error('Error deleting meeting:', error);
    }
  },

  getCurrency() {
    try {
      return localStorage.getItem('selectedCurrency') || 'USD';
    } catch (error) {
      console.error('Error reading currency:', error);
      return 'USD';
    }
  },

  setCurrency(currency) {
    try {
      localStorage.setItem('selectedCurrency', currency);
    } catch (error) {
      console.error('Error saving currency:', error);
    }
  }
};